import React, { useState, useEffect } from 'react'
import { analyticsEvent } from '../../lib/utils'

/*
 * The address is assembled in the browser, so the static HTML a harvester
 * fetches contains no address at all. user and domain arrive as separate props
 * and are only joined after mount, which keeps a complete address out of the
 * JS bundle too - there is no string in the source for a regex to match.
 *
 * Once mounted this is an ordinary mailto link with the address as its text.
 * The previous version stored the address reversed and flipped it back with
 * direction: rtl, so screen readers announced the reversal verbatim and
 * copying the address produced it backwards.
 *
 * label renders in its place until then, and is what a visitor without
 * JavaScript sees, so it should read sensibly in the surrounding sentence.
 */
const Email = ({ user, domain, label, classNames }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <span className={classNames || ''}>{label}</span>
  }

  const addr = `${user}@${domain}`

  return (
    <a
      className={classNames || ''}
      href={`mailto:${addr}`}
      onClick={() => analyticsEvent('click', { name: 'email' })}
    >
      {addr}
    </a>
  )
}

export default Email
